import { useMemo, type PropsWithChildren } from "react";

import {
  captureEvent,
  identifyUser,
  resetUser,
  setAnalyticsGroups,
} from "./posthog";
import { AnalyticsContext } from "./analytics-context";

export const AnalyticsProvider = ({ children }: PropsWithChildren) => {
  const value = useMemo(
    () => ({
      captureEvent,
      identifyUser,
      resetUser,
      setAnalyticsGroups,
    }),
    [],
  );

  return (
    <AnalyticsContext.Provider value={value}>
      {children}
    </AnalyticsContext.Provider>
  );
};
